"use client";
import Link from "next/link";
import { RotateCcw } from "lucide-react";
import type { Locale } from "@/lib/i18n/config";
import "@/app/v2-status.css";

/** Kept out of the UI dictionaries so the error boundary doesn't ship them. */
const copy = {
  es: { title: "No podemos verificar esta edición", lead: "La fuente de datos no está disponible o su publicación cambió. No mostraremos cifras sin autorización vigente.", retry: "Volver a intentar", explore: "Explorar artículos", href: "/biblioteca", home: "Ir a Codifly", homeHref: "/" },
  en: { title: "We can't verify this edition", lead: "The data source is unavailable or its publication changed. We won't show figures without a current authorization.", retry: "Try again", explore: "Browse articles", href: "/en/articles", home: "Go to Codifly", homeHref: "/en" },
  pt: { title: "Não conseguimos verificar esta edição", lead: "A fonte de dados está indisponível ou a publicação dela mudou. Não mostramos números sem uma autorização vigente.", retry: "Tentar novamente", explore: "Ver artigos", href: "/pt/artigos", home: "Ir para a Codifly", homeHref: "/pt" },
} satisfies Record<Locale, unknown>;

export function RouteError({ locale, reset }: { locale: Locale; reset: () => void }) {
  const t = copy[locale];
  return <div className="ui-root tl-page"><main id="main-content" className="ui-container tl-empty">
    <section className="tl-empty-card" role="alert" aria-labelledby="route-error-title">
      <h1 id="route-error-title">{t.title}</h1>
      <p>{t.lead}</p>
      <div className="tl-actions">
        <button type="button" className="ui-btn ui-btn-primary ui-btn-lg" onClick={reset}><RotateCcw aria-hidden="true" /> {t.retry}</button>
        <Link prefetch={false} className="ui-btn ui-btn-outline ui-btn-lg" href={t.href}>{t.explore}</Link>
        <Link prefetch={false} className="ui-btn ui-btn-ghost ui-btn-lg" href={t.homeHref}>{t.home}</Link>
      </div>
    </section>
  </main></div>;
}
